import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from "axios";
import { Toaster, toast } from "sonner";
import Select from 'react-select';
import { FaCircleXmark } from "react-icons/fa6";
import {
  loadingToggleAction,
  studentLoginAction,
} from "../../store/actions/AuthActions";

// image
import BgImage from "../../images/bg1.png";
import logo from "../../images/gurusidebar.png";
import logolight from "../../images/logo-white.png";
import pol from "../../images/pol.jpg";
import { API_BASE_URL } from "../../utils/constants";
import { isOk, loginObjData } from "../../utils/ResuableFuncction";
import { runLogoutTimer, saveTokenInLocalStorage } from "../../services/AuthService";
import { Spinner } from "react-bootstrap";

let errorsObj = {
  name: "",
  phone: "",
  password: "",
  confirmpassword: "",
};

function StudentForgotPassword(props) {
  const location = useLocation();
  const phone = new URLSearchParams(location.search).get("phone");
  
  const [password, setPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState(errorsObj);
  const [loader, setLoader] = useState(false);

const [otp, setOtp] = useState("");


useEffect(() => {
  if (phone) {
    handleForgotPassword(phone);
  }
}, [phone]);

// Function to handle forgot password
const handleForgotPassword = async (phone) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/student-forget-password-otp`, { phone, key:"forgetpasswordforstudent" });
    
    // Handle successful response
    console.log(response.data);  // You can handle success response here

  } catch (error) {
    // Handle error
    console.error("Error:", error);
    setErrors("Failed to send OTP. Please try again.");
  }
};

const validatePasswords = () => {
    const newErrors = {};
    
    if (!password) {
      newErrors.password = "Password is required.";
    }
  
    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password.";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
  
    setErrors(newErrors);
  
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCreatePassword = async (event) => {
    // Prevent default form submission behavior
    event.preventDefault();
  
    let newErrors = {};
  
    // Validation for OTP, Password, and Confirm Password
    if (!otp) {
      newErrors.otp = "OTP is required.";
    }
  
    if (!password) {
      newErrors.password = "Password is required.";
    }
  
    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password.";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
  
    // If there are validation errors, show them and prevent API call
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
  
    // Clear previous errors
    setErrors('');
  
    // Start the loader
    setLoader(true);
  
    try {
      // Make the API call to reset the password
      const response = await axios.post(
        `${API_BASE_URL}/api/student-forget-password`,
        {
          phone,
          key: "forgetpasswordforstudent",
          password,
          password_confirmation: confirmPassword,
          otp
        }
      );
  
      // Success: Show success toast and navigate to login page
      toast.success('Password reset successful! Please login.');
  
      // Redirect to login page after success
      navigate('/student/login');
  
      // Reset loader and clear form if needed
      setLoader(false);
    } catch (error) {
      // Error handling: Display an error toast
      console.error("Error resetting password:", error);
  
      toast.error("Failed to reset password. Please try again.");
  
      // Reset loader and show error message
      setErrors("Failed to reset password. Please try again.");
      setLoader(false);
    }
  };

  return (
    <div className="container h-100">
      <div className="row h-100 align-items-center justify-content-center">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="row m-0">
              <div
  className="col-xl-6 col-md-6 sign text-center sign-bg d-flex align-items-center justify-content-center"
  style={{
    backgroundImage: 'linear-gradient(to top, #f7ad34, white)',
  }}
>
                  <div>
                    <Link to={"#"} className="d-flex flex-column align-items-center">
                      <img className="logo-abbr dark-logo" width="250" src={logo} alt="Logo" />
                      <p
                        className="fw-bold"
                        style={{
                          fontSize: '2rem',
                          marginTop: '0.5rem', // Adjusts the spacing between the image and text
                          color: '#ffde00',
                          textShadow: '0.5px 0.5px 0px black, -1px 0.5px 0px black, 0.5px -1px 0px black, -1px -1px 0px black'
                        }}
                      >
                        Guru Dakshina
                      </p>
                    </Link>
                  </div>
                </div>
                <div className="col-xl-6 col-md-6">
                  <div className="sign-in-your px-2">
                    <h4 className="fs-20">Forgot Password</h4>
                    <span>Enter OTP sent to your phone to create new password.</span>
                     {/* Tabs for Login and Register */}
                    {props.errorMessage && (
                      <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                        {props.errorMessage}
                      </div>
                    )}
                    {props.successMessage && (
                      <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                        {props.successMessage}
                      </div>
                    )}
                    <form>

 {/* OTP Section (Visible until OTP is verified) */}

        <div className="mb-3">
          <label className="mb-1 pt-3"><strong>OTP</strong></label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter the OTP"
              maxLength={6}
            />
          </div>
          {errors.otp && <div className="text-danger fs-12">{errors.otp}</div>}
        </div>
      

      {/* Password Sections (Visible after OTP is verified) */}
      
      {/* <div>
      <label className="mb-1 pt-3">
                  <strong>Phone</strong>
                </label>
                <input
  type="tel"
  className="form-control"
  value={phone}
  placeholder="Type Your Phone Number"
  maxLength={10}
  inputMode="numeric"
/>
                {<div className="text-danger fs-12">{errors.phone}</div>}
              </div> */}
        <>
          <div className="mb-3">
            <label className="mb-1"><strong>Create Password</strong></label>
            <div className="input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-control"
                value={password}
                placeholder="Type Your New Password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash size={12} /> : <FaEye size={12} />}
              </button>
            </div>
            {errors.password && <div className="text-danger fs-12">{errors.password}</div>}
          </div>

          <div className="mb-3">
            <label className="mb-1"><strong>Confirm Password</strong></label>
            <div className="input-group">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                className="form-control"
                value={confirmPassword}
                placeholder="Confirm Your Password"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash size={12} /> : <FaEye size={12} />}
              </button>
            </div>
            {errors.confirmPassword && <div className="text-danger fs-12">{errors.confirmPassword}</div>}
          </div>
          {/* <button
      className="btn px-2 btn-sm py-1 mb-4 mt-2 btn-outline-primary"
      onClick={() => navigate('/student/login')} // Navigate to 'student/login' on click
    >
      Login with Password
    </button> */}
          <div className="text-center">
  {loader ? (
    <button
      className="btn btn-primary btn-block"
      type="button"
      disabled
    >
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Submitting...
    </button>
  ) : (
    <button
      onClick={handleCreatePassword}
      className="btn btn-primary btn-block"
    >
      Submit
    </button>
  )}
</div>
        </>                 
                       
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};

export default connect(mapStateToProps)(StudentForgotPassword);